var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"h2 text-center"},[_vm._v(" "+_vm._s(_vm.labels.title)+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.devices),expression:"devices"}]},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.devices,"fields":_vm.fields,"responsive":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }